import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./index.less";
import FaeHeader from "../../components/FaeHeader";
import { Button } from "antd";
import SearchForm from "../../components/SearchForm/SearchForm";
import CommonTable from "@/components/MessageComponent/CommonTable";
import usePage from "@/hooks/usePage";
import { FAEOrderStatus, FAEOrderTableItem, FAESearchForm } from "@/types/technical";
import { getFAEOrderList, getFAEProjectDetail } from "@/api/technical";
import { useNavigate } from "react-router-dom";

const prefix = "fae-order";

const columns: any = [
  { title: '服务单号', dataIndex: 'sn', width: "16%" },
  { title: '服务单概述', dataIndex: 'title', width: "24%" },
  { title: '类型', dataIndex: 'productType', width: "10%" },
  { title: '状态', dataIndex: 'statusName', width: "10%" },
  { title: '最后操作时间', dataIndex: 'lastUpdateTime', width: "15%" },
  { title: '提出时间', dataIndex: 'proposeTime', width: "15%" },
  { title: '操作', dataIndex: 'operation', width: "10%" },

];
const MyOrder: React.FC = () => {
  const [tableData, setTableData] = useState<FAEOrderTableItem[]>([]);
  const pagination = usePage({ pageSize: 8, currentPage: 1 });
  const searchParamsRef = useRef<any>(null);
  const [submitOrderBtnVisible, setSubmitOrderBtnVisible] = useState<any>(true);
  const navigate = useNavigate();
  console.log("MyOrder render", tableData);
  const submitOrderUrl = '/technicalSupport/fae/order/submit';
  const orderDetailUrl = '/technicalSupport/fae/order/detail';
  /**
   * 提问按钮点击事件
   */
  const submitOrderClickHandle = useCallback(() => {
    console.log("我要提单");
    navigate(submitOrderUrl + '?type=create');
  }, []);
  /**
   * 提问按钮
   */
  const submitOrderBtn = useMemo(() => {
    return (
      <Button type="primary" disabled={submitOrderBtnVisible} onClick={submitOrderClickHandle}>
        我要提单
      </Button>
    );
  }, [submitOrderBtnVisible]);

  const onTableClickHandle = (e: any) => {
    console.log(e)
  }
  const onPageChange = (current: any) => {

    let params = {
      pageNumber: current,
      pageSize: pagination.pageSize
    }
    if (searchParamsRef.current) {
      params = {
        ...params,
        ...searchParamsRef.current.getSearch()
      }
    }
    console.log('分页改变', params, searchParamsRef.current);
    getTableData(params)
  }

  const getTableData = (params?: FAESearchForm) => {
    pagination.setTableLoading(true);
    // 获取数据
    getFAEOrderList(params).then(res => {
      console.log('getTableData', res);
      if (res.code === 200) {
        setTableData(res.result.records.map((item: any) => {
          return {
            ...item,
            key: item.id,
            sn: <div className="hover-underline" style={{ color: '#0F62FE', cursor: 'pointer' }}
              onClick={() => { navigate(`${orderDetailUrl}?id=${item.id}`) }}>
              {item.sn}
            </div>,
            operation: <div style={{ color:item.status==FAEOrderStatus.WAIT_AUDIT? '#0F62FE':'#999999', cursor: 'pointer' }}
              onClick={() => {item.status==FAEOrderStatus.WAIT_AUDIT&& navigate(`${submitOrderUrl}?type=edit&id=${item.id}`) }}>
              {item.status==FAEOrderStatus.ADOPTED?'工单已关闭':'编辑'}
            </div>,
          }
        }));
        pagination.setTotal(res.result.total);
        pagination.setCurrentPage(res.result.current);
      }
    }).catch(err => {
      console.error(err);
    }).finally(() => {
      pagination.setTableLoading(false);
    })
  }
  const searchSubmitHandle = useCallback(
    /**
     * 搜索
     * @param params 
     */
    (params: FAESearchForm, isSearch: boolean = true) => {
      console.log('searchSubmitHandle', params);
      isSearch && getTableData({ ...params, pageNumber: 1, pageSize: pagination.pageSize });
    }, []);

  const getProject = useCallback(
      /**
       * 获取项目详情
       */
      () => {
        getFAEProjectDetail().then(res => {
          console.log('getProject', res);
          if (res.code == 200) {
            
            if (!res.result?.enableFlag) {
              window.message.warning('您的FAE项目已过期/已禁用，请联系您的生态经理');
              // setSubmitOrderBtnVisible(true);
              return;
            }
            setSubmitOrderBtnVisible(false);
          }
        }).catch((err) => {
          console.error(err)
        })
      }, [])

  useEffect(() => {
    getProject();
    getTableData({
      pageNumber: 1,
      pageSize: pagination.pageSize
    });
  }, [])
  return (
    <div className={`${prefix} main-wrapper`}>
      <FaeHeader title="工单列表" rightSlot={submitOrderBtn} />
      <SearchForm onSubmit={searchSubmitHandle} ref={searchParamsRef} />
      <div className={`${prefix}-container`}>
        <CommonTable
          className={`${prefix}-table`}
          onClick={onTableClickHandle}
          pageChange={onPageChange}
          tableConfig={{
            columns: columns,
            dataSource: tableData,
            loading: {
              spinning:pagination.tableLoading,
              size: 'large'
            }
          }}
          showSelectText={false}
          paginationConfig={pagination}
        />
      </div>

    </div>
  );
};

export default MyOrder;
